import { useEffect } from "react";
import { generateStaticPieNode } from "../../graph-util";
import { calculatePieChunks } from "../../utils";
import { CreateControlNodeOnlyFn, ItemWithClassification } from "../../@types";
import { NetworkRepEntry } from "../../../network/@types/Url";

interface Props {
  data: NetworkRepEntry[] | undefined;
  renderer: CreateControlNodeOnlyFn;
  counts: number;
}
const useRenderNetworkReferencesSS = ({
  data: dynamicNetworkRepData,
  renderer: createControlNodeFromData,
  counts: totalCount
}: Props) => {
  useEffect(() => {
    if (!dynamicNetworkRepData) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "networkDynamicNode",
          label: "Contacted Network References",
          points: calculatePieChunks(
            dynamicNetworkRepData as ItemWithClassification[],
            (item: ItemWithClassification) => item.classification
          ),
          total: totalCount,
          radius: 70
        })
    });
  }, [createControlNodeFromData, dynamicNetworkRepData, totalCount]);
};

export default useRenderNetworkReferencesSS;
